import { User } from '../types';

let accessToken: string | null = null;
let currentUser: User | null = null;

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3400/api';

export function getAccessToken(): string | null {
  return accessToken;
}

export function getCurrentUser(): User | null {
  return currentUser;
}

export function setAuth(token: string, user: User): void {
  accessToken = token;
  currentUser = user;
}

export function clearAuth(): void {
  accessToken = null;
  currentUser = null;
}

export async function login(email: string, password: string): Promise<User> {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });

  const json = await res.json();
  if (!res.ok) throw new Error(json.message || 'Erro ao fazer login');

  setAuth(json.data.accessToken, json.data.user);
  return json.data.user;
}

export async function refresh(): Promise<string> {
  const res = await fetch(`${API_URL}/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
  });

  const json = await res.json();
  if (!res.ok) throw new Error(json.message || 'Sessão expirada');

  accessToken = json.data.accessToken;
  if (json.data.user) currentUser = json.data.user;
  return json.data.accessToken;
}

export async function logout(): Promise<void> {
  try {
    await fetch(`${API_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });
  } finally {
    clearAuth();
  }
}

export async function me(): Promise<User> {
  const res = await fetch(`${API_URL}/auth/me`, {
    credentials: 'include',
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });

  const json = await res.json();
  if (!res.ok) throw new Error(json.message || 'Não autenticado');

  currentUser = json.data;
  return json.data;
}
